var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pairmain"},[_c('h1',[_vm._v("Choose a Second Character")]),_c('CharacterInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }